"use client";

import { Target, Users, Lightbulb } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MissionAndValues() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const values = [{
    icon: Target,
    title: "Our Mission",
    description: "We strive to deliver exceptional cloud accounting solutions that empower businesses to thrive in the digital age. Our commitment is to simplify financial management through innovative technology and unparalleled expertise."
  }, {
    icon: Users,
    title: "Client-Centered",
    description: "Every decision we make is guided by our clients' success. We build lasting partnerships based on trust, transparency, and a deep understanding of your unique business needs and financial goals."
  }, {
    icon: Lightbulb,
    title: "Innovation First",
    description: "We continuously evolve our services and embrace cutting-edge technologies to stay ahead of industry trends. Our forward-thinking approach ensures you always have access to the best financial tools and strategies."
  }];
  const refs = [ref1, ref2, ref3];
  const visibilities = [isVisible1, isVisible2, isVisible3];
  return <section id="mission-values" className="bg-dark-section text-dark-foreground py-24 md:py-32">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {values.map((value, i) => {
          const Icon = value.icon;
          return <div key={i} data-index={i} ref={refs[i]} className={`flex flex-col items-center text-center transition-all duration-500 ${visibilities[i] ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
                <div className="group mb-6 relative">
                  <Icon className={`w-16 h-16 text-[var(--color-primary)] stroke-[1.5] transition-all duration-300 ease-[var(--ease-smooth)] group-hover:text-[var(--color-primary-hover)] group-hover:drop-shadow-[0_0_12px_var(--color-primary)] ${visibilities[i] ? "animate-draw-icon" : ""}`} style={{
                strokeDasharray: visibilities[i] ? "none" : "200",
                strokeDashoffset: visibilities[i] ? "0" : "200"
              }} />
                </div>
                <h3 className="text-[28px] font-semibold mb-4 tracking-[-0.2px]">
                  {value.title}
                </h3>
                <p className="text-[16px] leading-[1.6] text-[var(--color-dark-foreground)] opacity-90">
                  {value.description}
                </p>
              </div>;
        })}
        </div>
      </div>

      <style jsx>{`
        @keyframes draw-icon {
          to {
            stroke-dashoffset: 0;
          }
        }
        .animate-draw-icon {
          animation: draw-icon 0.8s ease-out forwards;
        }
      `}</style>
    </section>;
}